<div>
  <header>
    <div class="poe-header" [innerHTML]="poeHeader"></div>
  </header>
  <aur-page id="pacPageId" [hideHeader]="true">
    <header class="layoutheader" style="padding: unset"></header>
    <aur-card>
      <aur-grid>
        <aur-grid-area>
          <div class="stepper-header web-view-only web-min-width" style="overflow-y: hidden;">
            <ul class="StepProgress">
              <li class="StepProgress-item step " id="step1">
                <div>
                  <header class="header-left-panal">Select Documents</header>
                  <p class="sub-header-left-panal">Select documents and
                    confirm amounts for payment</p>
                </div>
              </li>
              <li class="StepProgress-item step " id="step2">
                <div>
                  <header class="header-left-panal">Payment Method</header>
                  <p class="sub-header-left-panal">Enter Billing Information for your Payment</p>
                </div>
              </li>
              <li class="StepProgress-item step " id="step3">
                <div>
                  <header class="header-left-panal">Review & Authorize</header>
                  <p class="sub-header-left-panal">Review your information and invoice amounts for payment</p>
                </div>
              </li>
             
            </ul>
          </div>
        </aur-grid-area>
        <aur-grid-area colspan="3">
          <div>
            <div class="tab stepper-content device-content">
              <div *ngIf="showChild" class="stepper-content device-content " id="docScreen">
                <router-outlet></router-outlet>
              </div>
            </div>
            <div class="tab stepper-content device-content">
            </div>
            <div class="tab stepper-content device-content">
            </div>
          </div>
        </aur-grid-area>
      </aur-grid>
      <p-dialog header="Have Questions? Contact Us" [(visible)]="largeDialogVisible" [modal]="true">
        <P [innerHTML]="poeContact"></P>
      </p-dialog>
    </aur-card>
  </aur-page>
  <footer>
    <div class="poe-footer" [innerHTML]="poeFooter"></div>
    <div style="text-align: center;"><a [routerLink]="" (click)="largeDialogVisible = true">Contact Us</a>
    </div>
  </footer>
</div>